// react
import React from "react";

import { faWrench } from "@fortawesome/pro-regular-svg-icons";
// dependencies
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

// components
import Icon from "../../components/Icon";
// config
import Config from "./Config";

import PropTypes from "../../lib/prop-types";

// styles
import css from "./DropDownMenu.module.scss";

/**
 * @deprecated
 * */
export default class DropDownMenu extends React.Component {
	static propTypes = {
		onChange: PropTypes.func,
		width: PropTypes.number,
		height: PropTypes.number,
		options: PropTypes.arrayOf(PropTypes.object),
	};

	static defaultProps = {
		options: [],
		height: 36,
		width: 200,
		onChange: () => {},
	};

	state = {
		isOpen: false,
	};

	constructor(props) {
		super(props);
		this._ignoreBlur = true;
	}

	onClick = (name) => {
		this.props.onChange(name);
		this.toggleOpenState();
	};

	setIgnoreBlur = (ignoreState) => {
		this._ignoreBlur = ignoreState === undefined ? !this._ignoreBlur : ignoreState;
	};

	handleBlur = () => {
		if (!this._ignoreBlur) {
			this.toggleOpenState();
		}
	};

	toggleOpenState = () => {
		const nextState = !this.state.isOpen;

		this.setState({ isOpen: nextState }, () => {
			if (nextState) {
				document.addEventListener("click", this.handleBlur, false);
			} else {
				document.removeEventListener("click", this.handleBlur, false);
			}
		});
	};

	render() {
		const { isOpen } = this.state;
		const { width, height, options } = this.props;

		const elementHeight = height - 2;

		return (
			<div
				style={{ width, height }}
				className={`${css.cpDropDownMenu} cp-drop-down-menu ${isOpen ? `${css.isOpen} is-open` : ""}`}
			>
				<div
					onClick={this.toggleOpenState}
					style={{ height: elementHeight }}
					className={`${css.buttonContainer} button-container`}
					onMouseLeave={() => this.setIgnoreBlur(false)}
					onMouseEnter={() => this.setIgnoreBlur(true)}
				>
					<div style={{ lineHeight: `${elementHeight}px` }} className={`${css.label} label`}>
						Options
					</div>
					<div
						style={{
							lineHeight: `${elementHeight}px`,
							top: (elementHeight - Config.iconSize) / 2,
						}}
						className={`${css.menuIcon} menu-icon`}
					>
						<Icon type="fa5" name={faWrench} size={Config.iconSize} />
					</div>
				</div>

				{isOpen ? (
					<section style={{ top: elementHeight + 5 }} className={`${css.menuOptions} menu-options`}>
						{options.map((o) => {
							const option = o;
							let icon = null;

							if (option.icon) {
								icon = (
									<div
										style={{
											top: option.icon.type === "fa5" ? 0 : (elementHeight - Config.iconSize) / 2,
										}}
										className={`${css.menuIcon} menu-icon`}
									>
										<Icon type={option.icon.type} name={option.icon.name} size={Config.iconSize} />
									</div>
								);
							} else if (option.iconLayer) {
								icon = (
									<div style={{ top: 0 }} className={`${css.menuIcon} menu-icon`}>
										<span className="fa-layers fa-fw">
											{option.iconLayer.map((iconObject) => (
												<FontAwesomeIcon key={iconObject.name} {...iconObject} />
											))}
										</span>
									</div>
								);
							}

							return (
								<div
									key={option.name}
									onClick={() => this.onClick(option.name)}
									style={{ lineHeight: `${elementHeight}px` }}
									className={`${css.menuOption} menu-option`}
								>
									{option.label}
									{icon}
								</div>
							);
						})}
					</section>
				) : (
					""
				)}
			</div>
		);
	}
}
